"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Rubik_Regular_ttf_1 = __importDefault(require("../assets/fonts/Rubik-Regular.ttf"));
const Rubik_Medium_ttf_1 = __importDefault(require("../assets/fonts/Rubik-Medium.ttf"));
const Rubik_SemiBold_ttf_1 = __importDefault(require("../assets/fonts/Rubik-SemiBold.ttf"));
const MaterialIcons_Regular_ttf_1 = __importDefault(require("../assets/fonts/MaterialIcons-Regular.ttf"));
const theme_1 = __importDefault(require("./theme"));
const typography_1 = require("./typography");
/**
 * These are the global styles injected into the document.
 * They affect the entire app, please edit with care.
 */
const GlobalStyles = styled_components_1.createGlobalStyle `
  @font-face {
    font-family: 'Rubik';
    src: url('${Rubik_Regular_ttf_1.default}') format('truetype');
    font-weight: 400;
  }
  @font-face {
    font-family: 'Rubik';
    src: url('${Rubik_Medium_ttf_1.default}') format('truetype');
    font-weight: 500;
  }
  @font-face {
    font-family: 'Rubik';
    src: url('${Rubik_SemiBold_ttf_1.default}') format('truetype');
    font-weight: 600;
  }
  @font-face {
    font-family: 'Material Icons';
    font-style: normal;
    font-weight: 400;
    src: url('${MaterialIcons_Regular_ttf_1.default}') format('truetype');
  }
  *,
  *:before,
  *:after {
    box-sizing: border-box;
  }
  body {
    ${typography_1.defaultText}
    color: ${theme_1.default.colors.textDefault};
    font-family: ${theme_1.default.font.family.sans};
    font-weight: ${theme_1.default.font.weight.normal};
    letter-spacing: 0.1px;
    margin: 0;
  }
  #root {
    width: 100%;
    height: 100%;
  }

  .material-icons {
    font-family: 'Material Icons', sans-serif;
    font-weight: normal;
    font-style: normal;
    font-size: 24px;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
`;
exports.default = GlobalStyles;
